import type { Member } from '../../lib/supabase'
import { initialsOf, memberTint } from '../../lib/initials'

/** Up to three family avatars, overlapped, then "+n". Household order, as everywhere,
 *  so colours and positions agree with the member list in Settings. */
export function Avatars({ members, fallbackInitial = '?', max = 3 }: { members: Member[]; fallbackInitial?: string; max?: number }) {
  if (!members.length) {
    return <span className="ml-avatars" aria-hidden="true"><span className="ml-avatar" style={{ background: memberTint(0) }}>{fallbackInitial}</span></span>
  }
  const shown = members.slice(0, max)
  return (
    <span className="ml-avatars" aria-hidden="true">
      {shown.map((m, i) => (
        <span key={m.id} className="ml-avatar" style={{ background: memberTint(i) }}>{initialsOf(m.display_name)}</span>
      ))}
      {members.length > max && <span className="ml-avatar ml-avatar--quiet">+{members.length - max}</span>}
    </span>
  )
}
